import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import * as $ from "jquery";
import { ApiService } from "src/app/core/services/shared/api.service";

import {
  CodehelpService,
  ConfigMapService,
  envMode,
  HttpService,
} from "virtue-form";
import { CommonHandlerService } from "./core/services/shared/common-handler.service";
import { GlobalVarService } from "./core/services/shared/global-var.service";
import { EncryptDecreptService } from "./core/services/shared/encrypt-decrept.service";
import { CheckLoginSessionService } from "./core/services/shared/check-login-session.service";

declare var applyOrgCss: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  a: any;
  constructor(
    private titleService: Title,
    private router: Router,
    private apiservice: ApiService,
    public globalvar: GlobalVarService,
    private codehelp: CodehelpService,
    private common: CommonHandlerService,
    private configService: ConfigMapService,
    private httpser: HttpService,
    private EncryptDecrpt: EncryptDecreptService,
    private checkUserLogin: CheckLoginSessionService
  ) {
    // let checkUrlToPoint =this.common.checkAndSetAPIPoint("app.virtueanalytics.com");
    let checkUrlToPoint = this.common.checkAndSetAPIPoint(
      document.location.hostname
    );
    if (checkUrlToPoint == "Tech" || checkUrlToPoint == "Local") {
      this.configService.setProviderPoint(envMode.DEBUG); //Tech Point
      this.httpser.setEndPoint(envMode.DEBUG);
      // this.httpser.setEndPoint(
      //   envMode.OTHER,
      //   "https://tech.virtueanalytics.com/v-georgetown/"
      // );
      // this.httpser.setEndPoint(
      //   envMode.OTHER,
      //   "https://tech.virtueanalytics.com/v-college-location/"
      // );
    } else if (checkUrlToPoint == "Prod") {
      this.httpser.setEndPoint(envMode.PROD); //Production Point
      this.configService.setProviderPoint(envMode.PROD);
    } else {
      //  this.httpser.setEndPoint(envMode.OTHER , 'https://tech.virtueanalytics.com/v-top5Global')      this.configService.setProviderPoint(envMode.OTHER); // to set virtue provider id , if any other host
      // this.configService.setProviderPoint(envMode.OTHER); // to set virtue provider id , if any other host
    }
  }

  ngOnInit() {
    this.router.events.subscribe(async (navigationStart: any) => {
      const nav = navigationStart;
      this.globalvar.alreadyOrganizationLoaded.subscribe((isSave: boolean) => {
        let val = isSave == undefined ? true : isSave;
        if (!val) {
          if (nav.url != undefined) {
            const baseurlTop5 = "top5";
            const url_split = window.location.href.split("/");

            if (url_split[5] == "login" && url_split[6] == "0") {
              const decrypt_data = url_split[url_split.length - 1];
              const encrypted_split = decrypt_data.split("***");
              const decrypt_string = encrypted_split.join("/");
              const browser_decryt = decodeURIComponent(decrypt_string);

              if (
                browser_decryt != undefined ||
                browser_decryt != "undefined"
              ) {
                let decreptURL = JSON.parse(
                  this.EncryptDecrpt.get("govirtue@123", browser_decryt)
                );

                if (
                  decreptURL?.isLoginAsCounselor != undefined &&
                  decreptURL?.isLoginAsCounselor == true
                ) {
                  this.globalvar.isLoginAsCounselor = decreptURL;
                  // this.codehelp.setStoreValue("top5RequestLogin", "true");
                }

                if (
                  decreptURL?.accessToken != undefined &&
                  decreptURL?.isLoginFromDashboard == true
                ) {
                  this.globalvar.isLoginFromDashboard = decreptURL;
                  // this.codehelp.setStoreValue("top5RequestLogin", "true");
                }

                if (
                  decreptURL?.top5_request != undefined &&
                  decreptURL?.top5_request == true
                ) {
                  this.globalvar.isTokenLogin = true;
                  this.globalvar.top5SubscriptionDashboardRequestData =
                    decreptURL;
                  this.codehelp.setStoreValue("top5RequestLogin", "true");
                } else {
                  if (
                    decreptURL?.username != undefined &&
                    decreptURL?.password != undefined
                  ) {
                    this.globalvar.userLoginDetails = decreptURL;
                  }
                }
              }
            } else {
              const formFilledId = url_split[7];
              if (
                formFilledId != undefined &&
                formFilledId != "" &&
                formFilledId != null
              ) {
                this.globalvar.seFormFilledId = formFilledId;
              }
            }
            // const serviceUrlTop5 = "https://app.virtueanalytics.com/top5";
            const serviceUrlTop5 = window.location.origin + "/" + baseurlTop5;
            this.globalvar.basepath = baseurlTop5;
            // this.globalvar.organizationLoaded.subscribe((val) => {
            //   if (!val) {
            this.getOrganizationForTop5(serviceUrlTop5, baseurlTop5);
            // }
            // });
            this.globalvar.basepath = baseurlTop5;
            this.codehelp.setBaseUrl(this.globalvar.basepath); // to handle 401 request redirection
          }
        }
      });
    });
  }

  getOrganizationForTop5(serviceUrl: string, basePath: string) {
    if (!this.globalvar.isLoading) {
      this.globalvar.isLoading = true;
      this.apiservice
        .getOrganizationCSRtop5(serviceUrl, basePath)
        .subscribe((res) => {
          if (res[0]) {
            this.codehelp.setProviderID(res[0]["id"]);
            let csrServiceTypeData;
            if (basePath == "top5") {
              csrServiceTypeData = res[0].serviceConfigs.find(
                (sc) => sc.serviceType == "TOP5"
              );
            }

            this.globalvar.serviceConfig = csrServiceTypeData;
            this.globalvar.formId = csrServiceTypeData.formId;
            // this.globalvar.formId = "15714e20-3e3e-40a4-a2bb-b59ca9ae2fa5";
            if (res[0].uiConfig.styleFile) {
              const nameStyle = res[0].uiConfig["styleFile"].split(".");
              if (basePath == "top5") {
                applyOrgCss(`${nameStyle[0]}-top5.css`);
                localStorage.setItem("styleFile", `${nameStyle[0]}-top5.css`);
              }
            } else {
              applyOrgCss("");
              localStorage.removeItem("styleFile");
            }

            if (res[0]?.uiConfig?.siteTitle) {
              const title = res[0]?.uiConfig?.siteTitle.split(" ")[0];
              if (this.globalvar.basepath == "top5") {
                if (res[0]?.uiConfig?.siteTitle) {
                  localStorage.setItem("title", title);
                  this.titleService.setTitle("Top5 Colleges");
                }
              }
              let logoUrl =
                this.globalvar.getHost() +
                "fileStorage/download/" +
                res[0].uiConfig.logoId;
              this.globalvar.logoUrl = logoUrl;
              let favicon = res[0].uiConfig.faviconId;
              $('link[rel="icon"]').attr(
                "href",
                this.globalvar.getHost() + "fileStorage/download/" + favicon
              );
              if (csrServiceTypeData?.extraData) {
                let form = JSON.parse(csrServiceTypeData?.extraData);

                if (form?.feedbackFormId) {
                  this.getFeedBackFormData(form?.feedbackFormId);
                }
              }
              this.getAllState();
              this.getProductKey();
              this.getAllStateForCalculatorAlreadyExists();
              // this.globalvar.isLoading = false;
              // this.globalvar.hanleOrganizationLoading(true);
            } else {
              this.globalvar.isLoading = false;
            }
          }
        });
    }
  }
  getProductKey() {
    this.apiservice.getProductKeyontool((res: any) => {
      if (res) {
        this.globalvar.ProductKey = res.productId;
        this.apiservice.getpriceList(res.productId).then((resp: any) => {
          this.globalvar.PriceList = resp;
          console.log(this.globalvar.PriceList);
        });
      }
    });
  }

  getFeedBackFormData(formId: string) {
    this.apiservice.getFeedBackFormData(formId).then(
      (response: any) => {
        if (response?.filledByInfos) {
          this.globalvar.feedBackFormData = response;
        }
      },
      (error) => {
        if (error.status === 401) {
          this.checkUserLogin.onLogout("");
        }
      }
    );
  }

  getAllState() {
    this.apiservice.getstatelistall().then(
      (stateAllList: any) => {
        if (stateAllList) {
          let allState = [];
          Object.keys(stateAllList).forEach((key) => {
            const data = {
              id: key.toLowerCase(),
              label: stateAllList[key],
            };
            allState.push(data);
          });
          this.globalvar.getAllStateList.set("allState", allState);
          this.globalvar.getAllStateList = new Map(
            this.globalvar.getAllStateList
          );
          this.globalvar.isLoading = false;
          this.globalvar.loadOrganization(true, true, true);
        } else {
          this.globalvar.isLoading = false;
          this.globalvar.loadOrganization(true, true, true);
        }
      },
      (error) => {
        if (error.status === 401) {
          this.checkUserLogin.onLogout("");
        }
      }
    );
  }

  // getAllStateForCalculatorAlreadyExists() {
  //   this.apiservice.getstateForCalculatorExists().then((stateList: any) => {
  //     if (stateList.length > 0) {
  //       this.globalvar.getAllStateList.set(
  //         "stateListStateCalculator",
  //         stateList
  //       );
  //       this.globalvar.getAllStateList = new Map(
  //         this.globalvar.getAllStateList
  //       );
  //       this.globalvar.isLoading = false;
  //       this.globalvar.loadOrganization(true, true, true);
  //     }
  //   })
  // }
  getAllStateForCalculatorAlreadyExists() {
    this.apiservice.getstateForCalculatorExists().then(
      (stateList: any) => {
        if (stateList.length > 0) {
          this.globalvar.getAllStateList.set(
            "stateListStateCalculator",
            stateList
          );
          this.globalvar.getAllStateList = new Map(
            this.globalvar.getAllStateList
          );
          this.globalvar.isLoading = false;
          this.globalvar.loadOrganization(true, true, true);
        }
      },
      (error) => {
        if (error.status === 401) {
          this.checkUserLogin.onLogout("");
        }
      }
    );
  }
}
